import React, { useState } from 'react';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { getBlobSizeAsync } from '../../../api/Dashboard';
import { useDatoPanel } from '../useDatoPanel';
import KpiPanel from './KpiPanel';

const BlobSize = () => {
	const [size, setSize] = useState(0);
	const { cargando, error, recargar } = useDatoPanel(getBlobSizeAsync, (data) =>
		setSize(data.result)
	);

	return (
		<KpiPanel
			titulo="Almacenamiento"
			valor={size}
			icono={<CloudSyncIcon />}
			tono="info"
			cargando={cargando}
			error={error}
			onReintentar={recargar}
		/>
	);
};

export default BlobSize;
